export const toDangerousReactHtml = htmlString =>
    ({ __html: htmlString });

export default toDangerousReactHtml;
